import { render, staticRenderFns } from "./WorkTypeList.vue?vue&type=template&id=dd7a2536&scoped=true&"
import script from "./WorkTypeList.vue?vue&type=script&lang=js&"
export * from "./WorkTypeList.vue?vue&type=script&lang=js&"
import style0 from "./WorkTypeList.vue?vue&type=style&index=0&id=dd7a2536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7a2536",
  null
  
)

export default component.exports